module.exports = __webpack_public_path__ + "static/media/tabelaIR.83381223.jpg";